import Dispatcher from "../dispatcher";
import FractionStore from "./fraction-store";
import LibraryHelpers from "./library-helpers";

const LibraryStore = {
  _state: {
    bookList: [],
    coverURL: `${Fraction.Environment.coversHost}/vbid/:isbn/width/:width?style=preview`,
    jigsawBookCount: 0,
    loadingBookList: false,
    accessCodes: [],
    _: {
      bookLoadOffsets: [],
      perPage: 1000,
      booksLoading: 0
    }
  },

  // get the state of fraction
  get() {
    return this._state;
  },

  _updateState(state) {
    this._state = $.extend(this._state, state);
    Dispatcher.emit(Dispatcher.LIBRARY_UPDATED);
  },

  _loadOtherBooks(offset) {
    let obj = Fraction.Helpers.getDataObject("Library.BookList");
    Jigsaw.getBookList(
      {
        order: "recent",
        perPage: this._state._.perPage,
        offset: offset,
        eager: true,
        without_sso_only: true
      },
      response => {
        this._state._.booksLoading--;
        if (response.data.books.length > 0) {
          obj = Fraction.Helpers.getDataObject("Library.BookList");
          if (
            obj.books.length + response.data.books.length <
            response.data.total
          ) {
            for (var i = 0; i < 3; i++) {
              if (this._state._.bookLoadOffsets.length > 0) {
                this._loadOtherBooks(this._state._.bookLoadOffsets.pop());
                this._state._.booksLoading++;
              }
            }
          } else {
            this._updateState({ bookList: obj.books, loadingBookList: false });
          }
          obj.books = obj.books.concat(response.data.books);
          Fraction.Helpers.storeBookList(Fraction.User.email.hashMe());
          this._updateState({ bookList: obj.books });
          Fraction.Helpers.delayTimeout(
            () => {
              this._loadOtherBooks(1000000000);
              this._state._.booksLoading++;
            },
            1000,
            "loadingbookstimeout"
          );
        } else {
          if (
            this._state._.bookLoadOffsets.length === 0 &&
            this._state._.booksLoading === 0
          ) {
            Fraction.Helpers.storeBookList(Fraction.User.email.hashMe(), true);
            this._updateState({ bookList: obj.books, loadingBookList: false });
            LibraryHelpers.updateBookToast(obj.books);
          }
        }
      }
    );
  },

  loadBookList(refresh) {
    // First, get the User
    Fraction.Helpers.getUser(() => {
      // If the license is loading, break out
      if (FractionStore.get()["license-updating"]) {
        return;
      }
      if (Fraction.User.needsBookListUpdate) {
        Fraction.Helpers.clearStoredBookList(); // get rid of all that old junk // TODO just for this email?
        this._state._.bookLoadOffsets = [];
        this._state._.booksLoading = 0;
        Fraction.Helpers.userUpdateLicense({ auto: true });
        return;
      } else {
        // Get any cached booklists
        Fraction.Helpers.loadBookList(
          Fraction.User.email.hashMe(),
          Fraction.User.updatedBookListAt
        );
        const obj = Fraction.Helpers.getDataObject("Library.BookList");
        const bookListFinished = Fraction.Helpers.getDataObject(
          "Library.FinishedBookList"
        );
        if (
          !refresh &&
          obj.books &&
          obj.coverURL &&
          bookListFinished.finished
        ) {
          // There are books cached and they did finish loading last time
          this._updateState({
            coverURL: obj.coverURL,
            bookList: obj.books,
            jigsawBookCount: obj.books.length
          });
          LibraryHelpers.updateBookToast(obj.books);
        } else if (!this._state.loadingBookList) {
          // whoops! gotta reload them all!
          this._updateState({ loadingBookList: true });
          Fraction.Helpers.clearStoredBookList(); // get rid of all that old junk // TODO just for this email?
          this._state._.bookLoadOffsets = [];
          this._state._.booksLoading = 0;
          Jigsaw.getBookList(
            {
              order: "recent",
              perPage: 25,
              offset: 0,
              eager: true,
              without_sso_only: true
            },
            response => {
              if (response.status === "error") {
                Fraction.Helpers.signin(); // They are probably not logged in...
              } else {
                obj.coverURL = response.data.coverURL;
                this._updateState({ coverURL: response.data.coverURL });
                // Load other books in background
                if (response.data.books.length < response.data.total) {
                  var i;
                  for (
                    i = 1;
                    i <=
                    Math.ceil(
                      (response.data.total - 25) / this._state._.perPage
                    );
                    i++
                  ) {
                    this._state._.bookLoadOffsets.push(
                      25 + (i - 1) * this._state._.perPage
                    );
                  }
                  for (i = 0; i < 3; i++) {
                    if (this._state._.bookLoadOffsets.length > 0) {
                      this._loadOtherBooks(this._state._.bookLoadOffsets.pop());
                      this._state._.booksLoading++;
                    }
                  }
                } else {
                  this._updateState({ loadingBookList: false });
                }
                obj.books = response.data.books;
                Fraction.Helpers.storeBookList(
                  Fraction.User.email.hashMe(),
                  obj.books.length === response.data.total
                );
                this._updateState({
                  bookList: obj.books,
                  jigsawBookCount: response.data.total
                });
              }
            }
          );
        }
      }
    });
  },

  getAccessCode(isbn) {
    return this._state.accessCodes.find(license => license.isbn === isbn);
  },

  loadAccessCodes() {
    Jigsaw.getAllAccessCodes(response => {
      if (response.code === 200) {
        this._updateState({ accessCodes: response.data.licenses });
      }
    });
  },

  init() {
    Dispatcher.setMaxListeners(Dispatcher.getMaxListeners() + 1);
    Dispatcher.bind(Dispatcher.UPDATE_ACCESS_CODES, () =>
      this.loadAccessCodes()
    );
    Dispatcher.bind(Dispatcher.LICENSE_UPDATED, () => {
      setTimeout(() => {
        this.loadBookList(true);
      }, 0); // Needs to be at the end of the stack
      // TODO license-updating should actually exist in this store...
    });
  }
};

LibraryStore.init();
window.stores = window.stores || {};
window.stores.LibraryStore = LibraryStore;

export default LibraryStore;
